import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { APP_ROUTES } from './shared/enums';
import { NavigationEnd, Router } from '@angular/router';
import { ONBOARDING_ROUTES } from './shared/enums/appRoutes.enum';
import { UserProfileService, AuthService } from './core/services';
import { TranslationService } from './shared/services/translation.service';
import { EMPTY, forkJoin, switchMap, filter, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Cardio Explorer';
  APP_ROUTES = APP_ROUTES;
  showSidePanel = true;
  loading = true;
  private profileLoadAttempted = false;

  private destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    private userProfileService: UserProfileService,
    private translationService: TranslationService,
    private authService: AuthService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if(!event) return;
      if (event instanceof NavigationEnd) {
        this.showSidePanel = !Object.values(ONBOARDING_ROUTES).map(route => '/' + route).includes(this.router.url.split('?')[0]);
        this.loading = false;
        if (this.showSidePanel){
          this.checkAuthAndLoadProfile();
        }
      }
    });

  }

  /**
   * @description Checks if user is authenticated before loading user profile
   * Only loads profile once per app session to prevent duplicate API calls
   * @returns {void} void
   */
  private checkAuthAndLoadProfile(): void {
    if (this.profileLoadAttempted) {
      return;
    }
    this.authService.isAuthenticated().pipe(
      filter(isAuth => isAuth !== null),
      take(1)
    ).subscribe(isAuth => {
      if (isAuth) {
        this.profileLoadAttempted = true;
        this.loadUserProfile();
      }
    });
  }

  /**
   * @description Loads the user profile once when the app initializes
   */
  private loadUserProfile(): void {
    this.userProfileService.getUserProfile().pipe(
      takeUntilDestroyed(this.destroyRef),
      switchMap((profile) => {
        if (!profile) {
          return EMPTY;
        }

      return forkJoin({
          language:  this.translationService.setLanguage(profile.language),
          userId: this.authService.setCurrentUserId(profile.userId),
        });
      })
    )
    .subscribe({
      error: (error) => {
        const msg = error?.error?.message ?? error?.message ?? 'Unknown error';
        this.messageService.add({
          severity: 'error',
          //edit the message to be generic get profile fail
          detail: this.translate.instant('shared.toast.error.user_id_set_failed', { error: msg }),
          life: 3000,
        });
      }
    });
  }

}
